"use strict";

exports.__esModule = true;
exports.default = void 0;
var _addEventListener = _interopRequireDefault(require("./addEventListener"));
var _removeEventListener = _interopRequireDefault(require("./removeEventListener"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function listen(node, eventName, handler, options) {
  (0, _addEventListener.default)(node, eventName, handler, options);
  return function () {
    (0, _removeEventListener.default)(node, eventName, handler, options);
  };
}
var _default = exports.default = listen;